export default "__VITE_ASSET__ZnmtLVgT__"